import {
  ep,
  S9ComponentConfig,
  S9ComponentConfigCategory,
  S9ComponentConfigRelease,
} from '@april9au/stack9-sdk';
import * as ui from '@april9au/stack9-ui';
import { useScreen } from '@april9au/stack9-ui';

const DropdownTypeahead = ui.S9DropdownTypeahead.default;

export const config: S9ComponentConfig = {
  name: 'AccountQueryDropdown',
  icon: '',
  category: S9ComponentConfigCategory.GENERAL,
  version: S9ComponentConfigRelease.ALPHA,
  hasState: false,
  allowChildren: false,
  props: [],
};

type AccountQueryDropdownProps = {
  label: string;
  rules: [{ required: true }];
  name: string;
};

const AccountQueryDropdown = ({
  label,
  rules,
  name,
}: AccountQueryDropdownProps) => {
  const { screen } = useScreen();
  const screenKey = ep(screen && screen.head.key);
  return (
    <DropdownTypeahead<any>
      name={name}
      label={label}
      rules={rules || []}
      queryName="getaccountswithtextnumber"
      optionLabelProp="account_number"
      keyFilter="id"
      screenKey={screenKey}
      customMapLabelValue={(value: any) => ({
        value: value.id,
        label: value.account_number,
      })}
    />
  );
};
export default AccountQueryDropdown;
